module.exports = __webpack_public_path__ + "img/dashimg03.d70c2de0.png";